export default __webpack_public_path__ + "static/media/Fortune Sarah.0f2dda04.JPG";